
export class SoNumbersModel {
    saleOrderId: number;
    saleOrderNumber: string;
    poNumber?: string;
    status?: string;
    jobType?: string;
    processingUnit?:number;
    buyerPoNumber?: string
   
  
    /**
     * @param saleOrderId
    * @param saleOrderNumber
    
     */
    constructor(saleOrderId: number,saleOrderNumber: string,poNumber?:string,status?:string,jobType?: string,processingUnit?:number,buyerPoNumber?: string){
      this.saleOrderId = saleOrderId;
      this.saleOrderNumber = saleOrderNumber;
      this.poNumber = poNumber;
      this.status = status;
      this.jobType = jobType;
      this.processingUnit = processingUnit;
      this.buyerPoNumber = buyerPoNumber
    }
  }
  
  